var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.808 7.316a2.218 2.218 0 1 1 4.053 1.805L6.246 23.98a2.218 2.218 0 0 1-4.053-1.804l6.616-14.86zm16.947 0a2.218 2.218 0 1 1 4.053 1.805l-6.616 14.86a2.218 2.218 0 0 1-4.053-1.804l6.615-14.86zm-5.529-1.124a2.218 2.218 0 0 0-2.928 1.124l-3.308 7.43a2.218 2.218 0 1 0 4.052 1.805l3.308-7.43a2.218 2.218 0 0 0-1.124-2.928z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMed);
export default __webpack_public_path__ + "static/media/MED.76f222392b7196d2a26f4eec88c74372.svg";
export { ForwardRef as ReactComponent };